var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconInstagram = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  viewBox: "0 0 25 25"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "#41CD8C",
  strokeWidth: 2,
  width: 23,
  height: 23,
  rx: 6
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#41CD8C",
  strokeWidth: 2,
  cx: 11.5,
  cy: 11.5,
  r: 5.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#41CD8C",
  cx: 18.5,
  cy: 4.5,
  r: 1.5
}))));

export default SvgIconInstagram;